angular
    .module('app')
    .directive("limitToMaxMin", function() {
        return {
            link: function(scope, element, attributes) {
                element.on("blur", function() {
                    var value = element.val()
                    var min = Number(attributes.min);
                    var max = Number(attributes.max);

                    if (value > max) {
                        element.val(max);
                    }

                    if (value < min) {
                        element.val(min);
                    }
                });
            }
        };
    });
